<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <template v-if="getUser.role === 'owner'">
          <h5 class="mt-2">
            {{ meta.totalCount > 0 ? `Veículos ativos cadastrados: ${meta.totalCount}` : 'Nenhum veículo cadastrado' }}
          </h5>
        </template>
        <template v-else>
          <h5 class="mt-2">
            {{ meta.totalCount > 0 ? `Veículos ativos cadastrados: ${meta.totalCount}` : 'Nenhum veículo cadastrado ou você não possui acesso' }}
          </h5>
        </template>
      </div>
      <div class="col-md-6 text-right">
        <button @click="find(true)" class="btn btn-primary ml-4"><RefreshCcwIcon/></button>
        <router-link tag="button" to="definitions?tab=vehicles" class="btn btn-primary btn-xl ml-2">Ver todos</router-link>
      </div>
    </div>

    <table class="table table-borderless table-border table-align">
      <thead>
        <tr>
          <th>Placa</th>
          <th>Renavam</th>
          <th>UF</th>
          <th>CPF/CNPJ</th>
          <th>Criado por</th>
          <th>Criado Em</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="vehicle in vehicles" :key="vehicle.id">
          <td><strong>{{ vehicle.plate }}</strong></td>
          <td><strong>{{ vehicle.renavam}}</strong></td>
          <td><strong>{{ vehicle.uf }}</strong></td>
          <td><strong>{{ (vehicle.cpfCnpj || '-') }}</strong></td>
          <td><strong>{{ vehicle.createdBy }}</strong></td>
          <td><strong>{{ vehicle.createdAt | datetime }}</strong></td>
        </tr>
      </tbody>
    </table>
  </div>

</template>

<script>
  import EntityProxy from '@/models/EntityProxy'
  import GetAccount from '@/mixins/GetAccount.vue'
  import ModelMapper from '@/mixins/ModelMapper'
  import GetUser from '@/mixins/GetUser.vue';
  import { RefreshCcwIcon } from 'vue-feather-icons'
  import { VEHICLE_STATUS } from '@/utils/vehicleStatus'

  export default {
    components: { RefreshCcwIcon },
    computed: {
      vehicles() {
        return this.getModels || []
      },
    },
    created() {
      this.addOrderBy('created_at')
      this.$set(this.query, 'entityStatusId', VEHICLE_STATUS.ENABLED)
      this.find()
    },
    data() {
      return {
        nameModel: 'Vehicle'
      }
    },
    methods: {
      find(force) {
        const key = this.$name()

        const data = this.$ls.get(key)
        if (!force && data) {
          this.setModels(EntityProxy.build(data.vehicles))
          this.setMeta(EntityProxy.build(data.meta))
          return
        }

        this.asyncTemplateSelect({
          after: ({models, meta}) => this.$ls.set(key, { meta: meta, vehicles: models }, { minutes: 10 })
        })
      }
    },
    mixins: [ModelMapper, GetAccount, GetUser],
    name: 'DashboardVehicle'
  }
</script>

<style scoped>

</style>
